module.exports = __webpack_public_path__ + "static/media/industrial-tech.5577c292.jpg";